// Artikeltext ohne eigene H1.
// Die Blogseite setzt den Titel selbst als einzige H1. Outrank liefert den
// Titel zusätzlich als „# …“ in der ersten Zeile mit, dadurch hatte jede
// Seite zwei H1. Eine führende H1 entfällt deshalb, jede weitere H1 wird zur
// H2. Überschriften in Code-Blöcken bleiben unberührt.

const H1_RE = /^#(?!#)[ \t]+/;
const FENCE_RE = /^\s*(```|~~~)/;

export function normalizeArticleHeadings(md: string): string {
  if (!md) return md;
  const lines = md.split(/\r?\n/);
  const out: string[] = [];
  let inFence = false;
  let seenContent = false;

  for (const line of lines) {
    if (FENCE_RE.test(line)) {
      inFence = !inFence;
      seenContent = true;
      out.push(line);
      continue;
    }
    if (!inFence && H1_RE.test(line)) {
      if (!seenContent) {
        seenContent = true;
        continue;
      }
      out.push(`#${line}`);
      continue;
    }
    if (line.trim() !== "") seenContent = true;
    out.push(line);
  }

  return out.join("\n").replace(/^\s*\n/, "");
}
